import { render } from "./TrainingChart.vue?vue&type=template&id=b2ee79ac&ts=true"
import script from "./TrainingChart.vue?vue&type=script&lang=ts"
export * from "./TrainingChart.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__